// 首年限时加费
export default {
  data() {
    return {
      list: [],
      curHead: [],
      initItem: {},
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '方案名称',
          key: 'name',
          align: 'center',
          minWidth: 120
        }
      ];
      const headList = this.headList.map(item => ({
        title: item.name,
        key: item.code,
        align: 'center',
        minWidth: 120,
        render(h, params) {
          return <span>{params.row[item.code] || '-'}</span>;
        }
      }));
      columns = columns.concat(headList);
      columns.push({
        title: '费用率（%）',
        slot: 'commission',
        minWidth: 120,
        fixed: 'right',
        align: 'center'
      });
      this.columns = columns;
    },
    async initData(init) {
      const close = this.$notice.loading();
      await this.getPlanInfo();
      this.getColumns();
      const planMap = {};
      const tempCommissionList = [];
      this.initItem = {
        productCode: this.topItem.productCode,
        computeType: '1',
        expenseStartTime: '',
        expenseEndTime: ''
      };
      this.tableItem.programBaseList.forEach(bean => {
        bean.factors.forEach(bean2 => {
          bean[bean2.roleCode] = bean2.remark;
        });
        planMap[bean.id] = bean;
        const data = JSON.parse(JSON.stringify(bean));
        data.isMain = this.tableItem.isMain;
        data.gradeCode = this.tableItem.gradeCode;
        data.programId = data.id;
        data.commission = 0;
        tempCommissionList.push(data);
      });
      this.initItem.tempCommissionList = tempCommissionList;
      this.$http({
        url: '/buz/upcommission/queryConfigTempCommission',
        type: 'POST',
        data: {
          productCode: this.topItem.productCode,
          isMain: this.tableItem.isMain,
          gradeCode: this.tableItem.gradeCode
        }
      })
        .then(res => {
          if (res.data && res.data.length) {
            res.data.forEach(item => {
              item.key = item.id;
              item.expenseStartTime = item.expenseStartTime || '';
              item.expenseEndTime = item.expenseEndTime || '';
              // 已过期
              if (item.expenseEndTime < this.$units.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
              // 已开始
              if (item.expenseStartTime < this.$units.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')) {
                item.isSatrt = true;
              } else {
                item.isSatrt = false;
              }
              const list = JSON.parse(JSON.stringify(tempCommissionList));
              list.forEach(item2 => {
                item.tempCommissionList &&
                  item.tempCommissionList.forEach(item3 => {
                    if (item2.programId == item3.programId) {
                      item2.commission = item3.commission || 0;
                    }
                  });
              });
              item.tempCommissionList = list;
            });
            this.list = res.data;
          } else if (init) {
            const data = JSON.parse(JSON.stringify(this.initItem));
            data.key = Date.now();
            this.list = [data];
          } else {
            this.list = [];
          }
          if (this.over) {
            this.visible = true;
          }
        })
        .finally(() => {
          close();
        });
    }
  }
};
